import { makeStyles, tokens } from "@fluentui/react-components";

export const useStyle = makeStyles({
	button: {
		height: "2rem",
		flexShrink: 0,
		justifyContent: "flex-start",
		fontWeight: tokens.fontWeightRegular,
	}
});